import React from 'react';
import {Button, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {IntlShape} from 'react-intl';
interface propiedades {
  onClose: () => void;
  borrar: () => void;
  intl: IntlShape;
}

const ConfirmBorrar = (props: propiedades) => {
  const {onClose, borrar, intl} = props;

  return (
    <div className="modal fade show d-block" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <ModalHeader>
            {intl.formatMessage({id: 'confirm_delete_title'})}
          </ModalHeader>
          <ModalBody>
            {intl.formatMessage({id: 'confirm_delete_content'})}
          </ModalBody>
          <ModalFooter>
            <Button
              className="background-base border-0"
              onClick={() => {
                borrar();
                onClose();
              }}
            >
              {intl.formatMessage({id: 'accept'})}
            </Button>
            <Button className="background-primary border-0" onClick={onClose}>
              {intl.formatMessage({id: 'cancel'})}
            </Button>
          </ModalFooter>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBorrar;
